/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

export const unaccent = (text: string) => {
  const NOT_ASCII_RE = /[^ -~]/
  if (text.normalize && NOT_ASCII_RE.test(text)) {
    // https://stackoverflow.com/a/37511463/11506025
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }
  return text
}

export const hyphenize = (blob: string, unaccent_: boolean = true) => {
  if (blob) {
    // JS equivalent of: isEncoded = isinstance(blob, str)
    // https://github.com/FGRibreau/node-unidecode
    /*
    const isEncoded = false
    if isEncoded:
      blob = blob.decode('utf-8')
    if unaccent_:
      blob = unidecode.unidecode(blob)
    return result.encode('utf-8') if isEncoded else result
    */
    const result = blob && unaccent_ ? unaccent(blob) : blob
    return result
      .replace(/[^-\w']+/g, '-')
      .replace(/--+/g, '-')
      .replace(/(:?^-+|-+$)/g, '')
      .toLowerCase()
  }
  return ''
}

export function hyphenate(...parts: Array<string | undefined>) {
  return hyphenize(parts.filter(Boolean).join('-'))
}

export const toSlug = (
  cityName?: string,
  state?: string,
  hoodName?: string
) => {
  if (!cityName || !state) {
    return ''
  }

  const slug = `${hyphenate(
    unaccent(cityName)
  ).toLowerCase()}-${state.toLowerCase()}${
    hoodName ? `/${hyphenate(unaccent(hoodName)).toLowerCase()}` : ''
  }`

  return slug
}
